import { render, staticRenderFns } from "./NavApplicationMenuItem.vue?vue&type=template&id=6ad51ade"
import script from "./NavApplicationMenuItem.vue?vue&type=script&lang=ts"
export * from "./NavApplicationMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports